module.exports = __webpack_public_path__ + "static/wjazd-zima_thumb-259d7ac959ef2d3226be8cec0831905a.jpg";